import { ssoService } from '../request'

/**
 * 用户登录接口
 * @param {Object} loginData 登录数据 {username, password}
 * @returns {Promise} 返回Promise对象
 */
export const login = (loginData) => {
  return ssoService.post('/login', loginData)
}

/**
 * 验证初始化用户jwt
 * @returns {Promise} 返回Promise对象
 */
export const validate_token = () => {
  return ssoService.get('/validate-token')
}

/**
 * 删除用户
 * @param {Object} pwdData 登录数据 {password}
 * @returns {Promise} 返回Promise对象
 */
export const init_user = (pwdData) => {
  return ssoService.post('/init-user', pwdData)
}

// 退出登录
export function logout() {
  return ssoService.post('/logout')
}
/**
 * 发送找回密码验证码
 * @param {Object} data 手机号 {phone}
 * @returns {Promise} 返回Promise对象
 */
export const sendResetPasswordCode = (data) => {
  return ssoService.post('/password/send-code', data)
}

/**
 * 验证找回密码验证码
 * @param {Object} data 验证数据 {phone, code}
 * @returns {Promise} 返回Promise对象
 */
export const verifyResetPasswordCode = (data) => {
  return ssoService.post('/password/verify-code', data)
}

/**
 * 重置密码
 * @param {Object} data 重置密码数据 {phone, code, newPassword}
 * @returns {Promise} 返回Promise对象
 */
export const resetPassword = (data) => {
  return ssoService.post('/password/reset', data)
}

/**
 * 修改密码
 * @param {Object} data 修改密码数据 {oldPassword, newPassword}
 * @returns {Promise} 返回Promise对象
 */
export const changePassword = (data) => {
  return ssoService.post('/password/change', data)
} 
